import "./Loading.css"

import { useEffect, useState } from "react"
import classNames from "classnames"

import loadingGif from "web/icons/loading.svg"

export default function Loading({
  inline = false,
  delay = 500,
  message = "",
  hidden = false,
}) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handle = setTimeout(() => {
      setShow(true)
    }, delay)

    return () => {
      clearTimeout(handle)
    }
  }, [delay])

  if (!show) return <div />

  return (
    <div
      className={classNames(
        "loading-container grid grid-cols-1 place-content-center gap-1",
        {
          "fixed bottom-0 left-0 right-0 top-0 h-screen w-screen": !inline,
          hidden: hidden,
        }
      )}
    >
      <img src={loadingGif} alt="loading" draggable="false" />
      {message !== "" ? <p className="text-center">{message}</p> : ""}
    </div>
  )
}
